import ENDPOINTS from 'api/endpoints';
import { doGet, doPut } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type { Pronunciation, PronunciationsResponse } from './types';

export const getPronunciations = (accountId: string, projectId: string) => {
  return doGet<PronunciationsResponse>(
    generateNextPath(ENDPOINTS.PRONUNCIATIONS, {
      accountId,
      projectId,
    }),
    LOGGER_TYPE.JUPITER,
    { version: 'v2' },
  );
};

export const putPronunciations = ({
  accountId,
  projectId,
  pronunciations,
}: {
  accountId: string;
  projectId: string;
  pronunciations: Pronunciation[];
}) => {
  return doPut<PronunciationsResponse>(
    generateNextPath(ENDPOINTS.PRONUNCIATIONS, {
      accountId,
      projectId,
    }),
    LOGGER_TYPE.JUPITER,
    { pronunciations },
    { version: 'v2' },
  );
};
